import { render, staticRenderFns } from "./addProductScrap.vue?vue&type=template&id=24f3ee54&scoped=true&"
import script from "./addProductScrap.vue?vue&type=script&lang=js&"
export * from "./addProductScrap.vue?vue&type=script&lang=js&"
import style0 from "./addProductScrap.vue?vue&type=style&index=0&id=24f3ee54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f3ee54",
  null
  
)

export default component.exports